<script>
import i18n from '@/$plugins/i18n'
import { unflatten } from '@/assets/js/helper/object'

export default {
  props: {
    translations: {
      type: Object,
      default: undefined
    },
    translationsOnce: {
      type: Boolean,
      default: undefined
    },
    translationsPath: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      tPath: this.tPath
    }
  },
  beforeCreate () {
    const optionPropsData = this.$options.propsData ?? {}
    const translationsDefined = optionPropsData.translations !== undefined
    const translationsOnceDefined = optionPropsData.translationsOnce !== undefined
    const translationsPathDefined = optionPropsData.translationsPath !== undefined
    const translationsPath = (optionPropsData.translationsPath ?? this.$options.name ?? 'root').toLowerCase()
    const translationsAllreadySet = i18n.te(translationsPath)

    this.tPath = translationsPath

    // set translations to i18n if
    // has no translationsPath defined and
    // has translationsOnce not set to true or has translationsOnce set to true but tPath is not defined
    if (translationsDefined && !translationsPathDefined && (!translationsOnceDefined || (translationsOnceDefined && !translationsAllreadySet))) {
      const translationsData = optionPropsData.translations ?? {}
      const translations = unflatten(Object.keys(translationsData).reduce((t, tKey) => Object.assign(t, { [tKey.toLowerCase()]: translationsData[tKey] }), {}), '_')

      i18n.mergeLocaleMessage(i18n.locale, { [translationsPath]: translations })
    }
  }
}
</script>
